import {RouterProps} from "../../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {useEffect} from "react";
import {Body1, Spinner, Tab, TabList} from "@fluentui/react-components";
import {DetailDefaultPanel, DetailDefaultTab, DetailTab} from "../../../DetailViews";
import {
    AssetLunarExchangeOptionValueObject
} from "../../../../data/value-object/asset/AssetLunarExchangeOptionValueObject";
import {AssetLunarExchangeOptionIO} from "../../../../io/AssetIO";
import {
    AssetLunarExchangeOptionDescription
} from "../../../../data/description/asset/AssetLunarExchangeOptionDescription";
import {AssetLunarExchangeOptionDomain} from "../../../../data/domain/asset/AssetLunarExchangeOptionDomain";
import {AssetLunarExchangeOptionDescriptor} from "../../../../data/descriptor/asset/AssetLunarExchangeOptionDescriptor";

export default function Detail(props: RouterProps) {
    const params = useParams<{ assetLunarExchangeOptionId: string }>()
    const item = useStatePair<AssetLunarExchangeOptionValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.assetLunarExchangeOptionId !== undefined) {
            AssetLunarExchangeOptionIO
                .getById(BigInt(params.assetLunarExchangeOptionId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: AssetLunarExchangeOptionValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={AssetLunarExchangeOptionIO}
                description={AssetLunarExchangeOptionDescription}
                properties={props => <PropertyBody {...props} />} />
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof AssetLunarExchangeOptionDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "lunarAmount":
        case "solarAmount":
        case "createdAt":
        case "lastModifiedAt":
            return <Body1>{AssetLunarExchangeOptionDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{AssetLunarExchangeOptionDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}